import { render } from "./TagBubbleGroup.vue?vue&type=template&id=444d9512&scoped=true"
import script from "./TagBubbleGroup.vue?vue&type=script&lang=js"
export * from "./TagBubbleGroup.vue?vue&type=script&lang=js"

import "./TagBubbleGroup.vue?vue&type=style&index=0&id=444d9512&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-444d9512"]])

export default __exports__